import { useCallback, useEffect, useRef } from 'react';

// pls fix me
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebouncedCallback = <A extends any[]>(
  callback: (...args: A) => void,
  wait: number,
  abortOnUnmount = true,
): { callback: (...args: A) => void, abort: () => void } => {
  // track args & timeout handle between calls
  const argsRef = useRef<A | undefined>(undefined);
  const timeout = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const cleanup = useCallback(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
  }, []);

  // clean up the timer when our consuming component gets unmounted, except when opted out
  useEffect(
    () => () => {
      if (abortOnUnmount) {
        cleanup();
      }
    },
    [cleanup, abortOnUnmount],
  );

  const callbackInner = useCallback(
    (...args: A) => {
      // capture latest args
      argsRef.current = args;

      // clear debounce timer
      cleanup();

      // start waiting again
      timeout.current = setTimeout(() => {
        if (argsRef.current) {
          callback(...argsRef.current);
        }
      }, wait);
    },
    [callback, wait, cleanup],
  );

  return {
    callback: callbackInner,
    abort: cleanup,
  };
};
